/**
 * Design tokens partagés — importables côté serveur comme côté client
 * (theme.ts est « use client », donc les constantes utilisées dans les pages
 * vivent ici). Voir docs/site-design.md.
 */

/** L'unique ombre du site : douce et chaude (docs/site-design.md §Shape). */
export const softShadow = '0 6px 24px rgba(62,58,50,0.10)';
export const softShadowHover = '0 10px 30px rgba(62,58,50,0.16)';

/** La bande verte du brief (#5E7D5A) assombrie d'un cran pour que le texte crème
 *  atteigne 4,9:1 (le plancher de contraste prime — docs/design.md §3). */
export const sageBand = '#567350';

export const paperCream = '#FBF5E9';
export const apricotSoft = '#F3D9BC';
